import { useState } from 'react'

import { Button } from '@krp/ui-kit'

import { ReasonField } from '@krp/sale-ui'
import { RmkDialog } from '@krp/sale-ui'
import type { RegisterRowVm, RmkRights } from '../../model/types'

/**
 * «Освободить…» (UI-RMK-FLOW 3.11): только при праве, причина обязательна. «Сесть за кассу самому» — смена на
 * кассе не закрывается, работаете вы; «Закончить чужую работу» — только при закрытой смене и без незавершённых
 * продаж (правило службы). Чью работу закрывать, служба в списке касс пока не называет — тогда кнопки
 * выключены и сказано, что делать.
 */
export function ReleaseDialog({
  row,
  rights,
  onTakeover,
  onCloseForeign,
  onClose,
}: {
  row: RegisterRowVm
  rights: RmkRights
  onTakeover: (reason: string) => void
  onCloseForeign: (reason: string) => void
  onClose: () => void
}) {
  const [reason, setReason] = useState('')
  const ready = reason.trim().length > 0 && row.releaseUnavailableReason === null
  return (
    <RmkDialog title={`Освободить кассу: ${row.name}`} size="md" onClose={onClose}>
      <div className="aqsi-form">
        <p className="aqsi-card__text">{row.headline}</p>
        {row.releaseUnavailableReason !== null && <p className="aqsi-card__text">{row.releaseUnavailableReason}</p>}
        {rights.takeover && (
          <p className="aqsi-card__text">«Сесть за кассу самому»: смена на кассе не закроется — за кассу сядете вы.</p>
        )}
        {rights.closeAny && (
          <p className="aqsi-card__text">
            «Закончить чужую работу»: можно, только если смена на кассе закрыта и нет незавершённых продаж.
          </p>
        )}
        <ReasonField label="Причина (обязательно)" value={reason} onChange={setReason} />
        <div className="aqsi-card__actions">
          {rights.takeover && (
            <Button actionId="aqsi.rmk.takeover" disabled={!ready} onClick={() => onTakeover(reason.trim())}>
              Сесть за кассу самому
            </Button>
          )}
          {rights.closeAny && (
            <Button actionId="aqsi.rmk.close-foreign" disabled={!ready} onClick={() => onCloseForeign(reason.trim())}>
              Закончить чужую работу
            </Button>
          )}
          <Button variant="ghost" actionId="aqsi.rmk.cancel-dialog" onClick={onClose}>
            Отмена
          </Button>
        </div>
      </div>
    </RmkDialog>
  )
}
